import type {
  BidId,
  BidStatus,
  NoneableBillingMethod,
  PackageSource,
  ProjectId,
  ProjectStatus,
  ServiceLike,
} from '@mntn-dev/domain-types'

export type BidLike = {
  bidId: BidId
  amount?: number
  amountPlusMargin?: number
  status: BidStatus
}

export type CostLike = { cost?: number; costPlusMargin?: number }

export type PackageLike = {
  packageSource?: PackageSource
} & CostLike

export type ProjectLikeWithPricingFields = {
  chosenBillingMethod: NoneableBillingMethod
  projectId: ProjectId
  status: ProjectStatus
  bids?: BidLike[]
  projectServices?: ServiceLikeWithPricingFields[]
  services?: ServiceLike[]
  package?: PackageLike
  inherited: {
    package: PackageLike
  }
} & CostLike

export type ServiceLikeWithPricingFields = ServiceLike & CostLike

export const MakerPriceContext = 'agency'
export const BrandPriceContext = 'brand'
export type PriceContext = typeof MakerPriceContext | typeof BrandPriceContext

export const MakerPriceField = 'cost'
export const BrandPriceField = 'costPlusMargin'
export type CostLikeField = typeof MakerPriceField | typeof BrandPriceField

export const MakerBidPriceField = 'amount'
export const BrandBidPriceField = 'amountPlusMargin'

export const MakerPriceContextWithFields = {
  context: MakerPriceContext,
  priceField: MakerPriceField,
  bidPriceField: MakerBidPriceField,
} as const

export const BrandPriceContextWithFields = {
  context: BrandPriceContext,
  priceField: BrandPriceField,
  bidPriceField: BrandBidPriceField,
} as const

export type PriceContextWithField =
  | typeof MakerPriceContextWithFields
  | typeof BrandPriceContextWithFields
